export const DEPARTMENT_SUBGROUPS_MAP: Map<
  string,
  { id: string; text: string; setupsList: string[] }[]
> = new Map([
  [
    "accounting",
    [
      {
        id: "APSetups",
        text: "AP Setups",
        setupsList: [
          "AccountsPayable",
          "LaserFormTable",
          "Checks",
          "RemittanceFormMapping",
          "RemitToParent",
          "InvoiceAutoPost",
          "TruckAPInvoices"
        ],
      },
      {
        id: "ARSetups",
        text: "AR Setups",
        setupsList: [
          "AccountsReceivable",
          "CAPDefaults",
          "CREDefaults",
          "PaymentTypes",
          "ARPortal",
        ],
      },
      {
        id: "GLSetups",
        text: "GL Setups",
        setupsList: [
          "SaleChains",
          "Journals",
          "CashInBanks",
          "COA",
          "JournalTemplates",
          "RecurringJournalEntries",
          "ExpenseAllocations",
          "CashClearingSetup",
          "GLFiscalYearCalendar",
          "GLCalendar",
          "GLFiscalYearEnd",
          "IntercoTransfer",
          "WriteOffs",
          "GroupCodes",
          "BankRecon",
        ],
      },
      {
        id: "ETCSubgroup",
        text: "ETC Setups",
        setupsList: [
          "EtcAbsenceCodes",
          "EtcPayPeriod",
          "EtcTardyCodes",
          "EtcTimeZones",
          "EtcTechPayrollRecordTypes",
          "ETCTimeZonesMasterData",
          "EtcHolidays",
          "EtcPayrollFields",
          "ETCTimesheetDeclaration"
        ],
      },
      {
        id: "POSetups",
        text: "PO Setups",
        setupsList: [
          "POConfigurationGroup",
          "PORoleLevelInfo",
          "POUnitsOfMeasure",
          "POVendorChangeControl",
        ],
      },
      {
        id: "VendorSetups",
        text: "Vendor Setups",
        setupsList: [
          "VendorCategory",
          "VendorCompanyType",
          "VendorPaymentTypes",
          "VendorConfigurationGroup",
        ],
      },
    ],
  ],
]);
